<template>
    <!-- <vs-card> -->

    <div class="w-full expense-attachment">
        <vs-row vs-w="12" class="p-4">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="9" vs-sm="9" vs-xs="9">
                <h4 class="text-right"> {{ $t('files') | capitalize }} (.xlsx)</h4>
            </vs-col>
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="3" vs-xs="3">
                <expense-attachment-upload :expense_id="expense_id" @success="refresh" />
            </vs-col>
        </vs-row>
        <vs-row vs-w="12">
            <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-sm="12" vs-xs="12">
                <expense-attachment-list :data="data" />
            </vs-col>
        </vs-row>
    </div>
    <!-- </vs-card> -->
</template>

<script>

import ExpenseAttachmentList from './ExpenseAttachmentList.vue'
import ExpenseAttachmentUpload from './ExpenseAttachmentUpload.vue'
import request from './request.js'
export default {
    components: {
        ExpenseAttachmentList,
        ExpenseAttachmentUpload
    },
    props: {
        expense_id: {
            type: String,
        }
    },
    data() {
        return {
            data: []
        }
    },
    methods: {
        getAttachments() {
            this.data = []
            const payload = {
                id: this.expense_id
            }
            request
                .getAttachments(payload)
                .then((response) => {
                    this.data = [...response.data.attachments]
                })
                .catch((response) => {
                })
        },
        refresh(){
            this.getAttachments()
            this.$emit('update')
        }
    },
}
</script>

<style>
.expense-attachment {
    border: 1px solid #f2f3f4;
}
</style>